
export class EnvironmentHelper {
    isLocal() {
        let host = window.location.host
        return host === 'localhost' || host === '127.0.0.1'
    }

    isStaging() {
        let host = window.location.host
        return host === 'sonistaging.com' || host === 'www.sonistaging.com'
    }

    isQa() {
        let host = window.location.host
        return host === 'qa.sonicumonitoring.com'
    }

    isProduction() {
        let host = window.location.host
        return host === 'www.sonicumonitoring.com' || host === 'sonicumonitoring.com'
    }
}